@if (hrisIntegrationDataService.hrisIntegration; as hrisIntegration) {
  <div
    [class]="bgClass"
    class="flex w-full items-center justify-between gap-2 rounded-lg px-5 py-3"
  >
    <div class="flex items-center gap-2">
      <mat-icon class="material-icons-outlined hvs-icon-xxl text-blue-dark">
        link
      </mat-icon>
      <span class="text-base font-semibold">
        <span class="text-blue-dark">{{ hrisIntegration.providerName }}:</span>
        <span [class]="statusClass">
          {{
            'portal.hrisIntegration.statuses.' + hrisIntegration.status
              | transloco
          }}
        </span>
      </span>
    </div>
    <app-text-button (click)="goToTeam()">
      {{ 'portal.hrisIntegration.banner.teamSettings' | transloco }}
    </app-text-button>
  </div>
}
